

<div class="ipm-prodcuer-section">
    <!-- <div class="ipm-close-icon" (click)="closeByDeviceType()">
        <i class="pi pi-times"></i>
    </div> -->
    <h1 class="ipm-model-heading">Are you a music producer?</h1>
    <hr class="border-line">
    <p class="ipm-message">
        Start Selling your beats on Beat22 Music.
        Thousands of artists are doing it globally and getting recognised.
        it's your time to shine now!
    </p>
    <div class="d-flex buttons ipm-actions">
        <button class="maybe-button ipm-submit-btn" (click)="closingActionPerform('customer')" >No, I'm a buyer</button>
        <button class="join-now ipm-submit-btn" (click)="closingActionPerform('producer')">Yes, I want to sell</button>
    </div>
</div>
